import { EVENTS } from '@tandemone/types'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { navTabsFor } from '@/domains/app-shell'
import { track } from '@/domains/observability'

/** `page_viewed` on every navigation, including pre-auth. the full url is
 *  deliberately not sent: nothing queries it, and it can carry PII that
 *  signup already routes through history state to keep out of telemetry.
 */
export function usePageView(): void {
  const location = useLocation()
  /* a tab used to be its own page, so switching one is a view. only a name
   * from the page's own list is sent, never what was typed, and a missing or
   * unknown one is the tab the page actually lands on. */
  const tabs = navTabsFor(location.pathname)
  const asked = new URLSearchParams(location.search).get('tab')
  const tab = tabs ? (tabs.find(entry => entry === asked) ?? tabs[0]) : null

  useEffect(() => {
    track(
      EVENTS.PAGE_VIEWED,
      { referrer: document.referrer || null, tab: tab ?? null },
      { path: location.pathname }
    )
    /* pathname and tab only. depending on the whole search re-fired this for
     * every filter, sort and page change while still reporting the same path
     * -- ~12% phantom views, concentrated on the tools that have filters,
     * which skewed the tool-activity comparison against the ones that do
     * not. */
  }, [location.pathname, tab])
}
